import { render, staticRenderFns } from "./DashBoardPlugin.vue?vue&type=template&id=ba45845a&scoped=true"
import script from "./DashBoardPlugin.vue?vue&type=script&lang=ts"
export * from "./DashBoardPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./DashBoardPlugin.vue?vue&type=style&index=0&id=ba45845a&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ba45845a",
  null
  ,true
)

export default component.exports